export var ASSET_STATUS;
(function (ASSET_STATUS) {
    ASSET_STATUS["AVAILABLE"] = "AVAILABLE";
    ASSET_STATUS["SOLD"] = "SOLD";
    ASSET_STATUS["OFF_MARKET"] = "OFF_MARKET";
})(ASSET_STATUS || (ASSET_STATUS = {}));
export var ASSET_OCCUPANCY_TYPE;
(function (ASSET_OCCUPANCY_TYPE) {
    ASSET_OCCUPANCY_TYPE["VACANT"] = "VACANT";
    ASSET_OCCUPANCY_TYPE["TENANT"] = "TENANT";
    ASSET_OCCUPANCY_TYPE["OWNER_RESIDENT"] = "OWNER_RESIDENT";
})(ASSET_OCCUPANCY_TYPE || (ASSET_OCCUPANCY_TYPE = {}));
export var ASSET_PROGRAM;
(function (ASSET_PROGRAM) {
    ASSET_PROGRAM["FLEX"] = "FLEX";
    ASSET_PROGRAM["FIRM"] = "FIRM";
})(ASSET_PROGRAM || (ASSET_PROGRAM = {}));
//# sourceMappingURL=Assets.js.map